<!--
    @name: 分页组件样式重写
    @description: 默认展示无交互的el-pagination组件，外层传插槽交互
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-12-08 15:48:05
-->
<template>
  <div>
    <el-pagination v-bind="$attrs" v-on="$listeners">
      <slot></slot>
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "ui-page",
  inheritAttrs: false
}
</script>

<style scoped lang="scss">
/deep/ .el-pagination{
  padding:20px 0;
  .el-pagination__total{
    color: var(--FC6);
  }
  .el-pager{
    .active{
      color: var(--Czsd);
    }
    li{
      &:hover{
        color: var(--Czsd);
      }
    }
  }
  .el-input__inner{
    border-radius: 0;
    &:focus{
      border-color: var(--Czsd);
    }
  }
  button{
    &:hover{
      color: var(--Czsd);
    }
  }
}
</style>
